import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import parseQueryString from 'query-string';
import { decode } from 'js-base64';
import { parse, addDays, isBefore, format } from 'date-fns';
import Footer from './components/mainContent/footer';
import MainContent from './components/mainContent/mainContent';
import MainMenu from './components/mainContent/mainMenu';
import Header from './components/mainContent/header';
import { setParams, setVIP, setDirectBooking, setMode, setArrivalDate, setGuestNames, setPage,
         setBookings, setRates, setSavedBookingDetails, setPaymentReference } from './store/AppSlice';
import { retrievePaymentIntent } from './store/AppAPI';
import { getRates, getAvailability } from './database/database';

import './css/base.css';

const App = () => {

  const dispatch = useDispatch();

  const checkIfWelcome = (arrivalDate, guestNames) => {
    let dateOfArrival = parse(arrivalDate, 'yyyyMMdd', new Date());
    let endOfStayDate = addDays(dateOfArrival, 28);

    // Is today prior to the end of stay which is 28 days after the arrival date
    // This copes with the longest stay of 28 days
    if (isBefore(new Date(), endOfStayDate)) {
      dispatch(setMode("WELCOME"));
      dispatch(setArrivalDate(arrivalDate));
      dispatch(setGuestNames(guestNames));
      dispatch(setPage("WELCOME"));  
    }
  }

  useEffect(() => {

    let queryString = window.location.search;

    let query = parseQueryString.parse(queryString);
    dispatch(setParams(query));
    if (query.info) {
    let text = query.info;
    let decodedText = decode(text);
    let separatedParams = decodedText.split(/\r?\n/);

    if (separatedParams[0] && separatedParams[1]) {
      checkIfWelcome(separatedParams[0], separatedParams[1]);      
    }

    if (separatedParams[2] === "VIP") {
      dispatch(setVIP(true));
    } else {
      dispatch(setVIP(false));
    }
    }

    dispatch(setDirectBooking(true));

    getRates().then((rates) => {
    if (rates != null) {
      dispatch(setRates(rates));
    }
    });

    getAvailability().then((bookings) => { 
    if (bookings != null) {
      dispatch(setBookings(bookings));
    } 
    });


    let path = window.location.pathname;

    // If coming back after a successful Stripe payment then route to payment success page
    if (path === "/success") {
      let savedBookingDetails = JSON.parse(window.localStorage.getItem("booking-details"));
      dispatch(setSavedBookingDetails(savedBookingDetails));
      let savedBookings = JSON.parse(window.localStorage.getItem("bookings"));
      dispatch(setBookings(savedBookings));

      // Retrieve the "payment_intent" query parameter appended to
      // your return_url by Stripe.js
      const paymentIntent = new URLSearchParams(window.location.search).get('payment_intent');
      console.log("Payment intent value is: " + paymentIntent);

      if (paymentIntent) {
        dispatch(retrievePaymentIntent(paymentIntent));
        dispatch(setPaymentReference(paymentIntent));
      }
  
      window.localStorage.removeItem("booking-details");
      window.localStorage.removeItem("bookings");  
    }

  }, [dispatch]);

  return (
      <div className="container-fluid no-padding">
        <Header />

        <MainMenu />

        <MainContent />

        <Footer />
      </div>
  );

}

export default App;